import {
  ApiError,
  CbDataRequestInit,
  NetworkError,
  NonThrowingFetch,
  ReReadableOkResponse,
} from '@cbhq/data-layer';
import { getLoggableError } from '@cbhq/identity-shared/utils';

export function isUnauthorizedError<
  T extends ReReadableOkResponse | { error: string } | NetworkError | ApiError | string,
>(response: T): boolean {
  if (response instanceof ApiError) {
    return response.status === 401;
  }

  if (response instanceof Error) {
    return response.message.includes('UNAUTHORIZED');
  }

  if (typeof response === 'string') {
    return response.split(':')[0] === 'UNAUTHORIZED';
  }

  if (typeof response === 'object' && 'error' in response) {
    return response?.error?.split(':')[0] === 'UNAUTHORIZED';
  }

  return false;
}

export function unauthorizedErrorMiddleware(
  next: NonThrowingFetch,
  onUnauthorized: (error: Error) => void,
) {
  return async (url: string, init?: CbDataRequestInit) => {
    const response = await next(url, init);
    if (isUnauthorizedError(response)) {
      const error = getLoggableError(response);
      onUnauthorized(error);
    }
    return response;
  };
}
